import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Rx';

import { GUID, Param } from "app/brightserve/brightserve.module";
import { Incident, Observation } from "app/shared/shared.module";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { StreamingObservations, StreamingObservation } from '../shared/streaming-observations';

@Injectable()
export class CaseService {

    constructor(private http: HttpClient) { }

    GetCases(Status: string = ""): Observable<Incident[]> {
        var url = "/incident/list";
        if (Status != "")
            url = "/incident/" + Status + "/list";

        return this.http.get(url).map((res: any) => res.Incidents.map(i => new Incident(i)) || {});
    }

    GetCasePDF(Id: GUID){
        var mediaType = 'application/pdf';
        return this.http.post("/incident/" + Id + "/pdf", { location: "themis-incident-" + Id + ".pdf" }, { responseType: 'blob' });
    };

    GetCaseDetails(Id: GUID): Observable<Incident> {
        return this.http.get("/incident/" + Id).map((res: any) => new Incident(res.Incident));
    };

    GetObservationsForIncident(Id: GUID) {
        return this.http.get("/incident/" + Id + "/observation/list").map((res: any) => res.Observations.map(o => new Observation(o) || {}));
    }

    GetObservationsForPeriod(incidentId: GUID, period: number, offset: number = 0): Observable<any> {
        return this.http.get("/incident/" + incidentId + "/observations/period/" + period + "/" + offset)
            .map((res: any) => res || {});
    }

    GetObservationsGroupsForIncident(incidentId: GUID, param: Param): Observable<any> {
        return this.http.post("/observation/group/list", { IncidentId: incidentId, Type: param })
            .map((res: any) => res || {});
    }

    GetObservationGroupObservations(id: GUID): Observable<any> {
        return this.http.get("/observation/group/" + id + "/observations")
            .map((res: any) => res || {});
    }

    Generate12ECGImagesForIncident(incidentId: GUID, groupId: GUID): Observable<any> {
        return this.http.post("/observation/generate-12-ecg-images", { IncidentId: incidentId, ObservationGroupId: groupId })
            .map((res: any) => res || {});
    }

    GetStreamingDataForIncident(Id: GUID, TimeStamp: Date = null): Observable<StreamingObservations>  {
        return this.http.post("/incident/" + Id + "/observations/streaming/list", { IncidentId: Id, LastTimestamp: TimeStamp })
            .map((res: any) => new StreamingObservations(res));
    }

    ChangeIncidentStatus(Id: GUID, Status: string): Observable<any> {
        return this.http.post("/incident/" + Id + "/status/change", { Status: Status })
            .map((res: any) => res || {});
    }

    ListMediaItem(Id: GUID): Observable<any> {
        return this.http.get("/incident/" + Id + "/media/list")
            .map((res: any) => res || {});
    }
}



// WEBPACK FOOTER //
// ./src/app/case/case.service.ts